/*
 * FATCUTPRESS — VOID MODE background settings
 * Change only this file for small visual adjustments.
 * Replace void-background.js when switching to a completely new background.
 */
window.FATCUT_VOID_BACKGROUND = {
  lowReaction: 1.0,
  highReaction: 1.0,
  motionSpeed: 1.0
};
